<div id="container" class="app-background">
  <div id="topbar">
    <app-global-lang-chooser></app-global-lang-chooser>
  </div>

  <div class="min-h-screen flex align-items-center justify-content-center">
    <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6 max-w-30rem">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="text-center mb-5">
          <img src="assets/images/app_logo.png" alt="Image" height="50" class="mb-3" />
          <div class="text-900 text-3xl font-medium mb-3">
            {{ 'WELCOME_BACK' | translate }}
          </div>
          <span class="text-600 font-medium line-height-3">{{ 'DONT_HAVE_ACCOUNT' | translate }}</span>
          <a class="font-medium no-underline ml-2 text-blue-500 cursor-pointer" routerLink="/sign-up">{{ 'CREATE_TODAY'
            | translate }}</a>
        </div>

        <div>
          <label for="email1" class="block text-900 font-medium mb-2">{{ 'EMAIL' | translate }}</label>
          <input id="email1" type="text" placeholder="{{ 'EMAIL_ADDRESS' | translate }}" pInputText class="w-full mb-3"
            formControlName="email" />
          <div *ngIf="form.get('email')?.invalid && submitted" class="text-red-500 mb-2">
            <small *ngIf="form.get('email')?.errors?.['required']">{{ 'EMAIL_REQUIRED' | translate }}</small>
            <small *ngIf="form.get('email')?.errors?.['email']">{{ 'INVALID_EMAIL' | translate }}</small>
          </div>

          <label for="password1" class="block text-900 font-medium mb-2">{{ 'PASSWORD' | translate }}</label>
          <div class="p-inputgroup mb-3">
            <input id="password1" [type]="passwordVisible ? 'text' : 'password'"
              placeholder="{{ 'PASSWORD' | translate }}" pInputText class="w-full" formControlName="password" />
            <span class="p-inputgroup-addon p-0">
              <button type="button" pButton class="p-button-text p-0" (click)="togglePasswordVisibility()" tabindex="-1"
                style="box-shadow: none">
                <i class="pi" [ngClass]="passwordVisible ? 'pi-eye-slash' : 'pi-eye'"></i>
              </button>
            </span>
          </div>
          <div *ngIf="form.get('password')?.invalid && submitted" class="text-red-500 mb-2">
            <small *ngIf="form.get('password')?.errors?.['required']">{{ 'PASSWORD_REQUIRED' | translate }}</small>
          </div>

          <div class="flex align-items-center justify-content-end mb-6">
            <a class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer"
              (click)="onForgotPassword()">{{ 'FORGOT_PASSWORD' | translate }}</a>
          </div>

          <button pButton pRipple [label]="'SIGN_IN' | translate" icon="pi pi-user" class="w-full" type="submit"
            [disabled]="form.invalid"></button>
        </div>
      </form>
      <app-reset-password-dialog [(visible)]="showResetDialog"
        (confirm)="onResetPasswordConfirm()"></app-reset-password-dialog>
    </div>
  </div>
</div>

<p-dialog header="{{ 'TWO_FACTOR_AUTH' | translate }}" [(visible)]="show2FADialog" [modal]="true"
  [dismissableMask]="true" [closeOnEscape]="true" appendTo="body" [style]="{ width: '28rem' }">
  <div class="flex flex-column gap-3">
    <div class="flex align-items-center gap-3 mb-3">
      <i class="pi pi-envelope text-4xl text-primary"></i>
      <div class="text-600 line-height-3">
        Please check your email (and <span class="font-bold text-900">junk folder</span>) for your two-factor
        authentication code.
        <div class="mt-3">
          If you need support contact <a href="mailto:alec.kingsnorth@wolffsohnresearch.com"
            class="text-blue-500 no-underline font-medium">alec.kingsnorth&#64;wolffsohnresearch.com</a>
        </div>
      </div>
    </div>

    <div>
      <label for="twoFactorCode" class="block text-900 font-medium mb-2">
        {{ 'TWO_FACTOR_CODE' | translate }}
      </label>
      <input id="twoFactorCode" type="text" pInputText class="w-full" [(ngModel)]="twoFactorCode"
        autocomplete="one-time-code" />
    </div>

    <div class="flex justify-content-end">
      <button pButton type="button" [label]="'SUBMIT' | translate" icon="pi pi-check" (click)="check2faCode()"></button>
    </div>
  </div>
</p-dialog>